import { useState, ChangeEvent } from 'react';

import { RecipientFormData } from '../types/sharedBasket.types';

interface EmailFormErrors {
  firstName?: string;
  lastName?: string;
  email?: string;
}

interface EmailFormProps {
  formData: RecipientFormData;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  errors: EmailFormErrors;
  showAllErrors?: boolean;
}

const EmailForm = ({ formData, onChange, errors, showAllErrors = false }: EmailFormProps) => {
  const [touchedFields, setTouchedFields] = useState<Record<string, boolean>>({});

  const handleBlur = (fieldName: string) => {
    setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
  };

  const shouldShowError = (fieldName: keyof EmailFormErrors) =>
    (touchedFields[fieldName] || showAllErrors) && !!errors[fieldName];

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-sm font-semibold text-gray-900 mb-3">Recipients details:</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* First name */}
          <div>
            <label htmlFor="firstName" className="block text-sm text-gray-700 mb-1">
              First Name
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={onChange}
              onBlur={() => handleBlur('firstName')}
              className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black ${
                shouldShowError('firstName') ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {shouldShowError('firstName') && (
              <p className="text-xs text-red-500 mt-1">{errors.firstName}</p>
            )}
          </div>

          {/* Last name */}
          <div>
            <label htmlFor="lastName" className="block text-sm text-gray-700 mb-1">
              Last name
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={onChange}
              onBlur={() => handleBlur('lastName')}
              className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black ${
                shouldShowError('lastName') ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {shouldShowError('lastName') && (
              <p className="text-xs text-red-500 mt-1">{errors.lastName}</p>
            )}
          </div>
        </div>

        {/* Email address - full width */}
        <div className="mt-4">
          <label htmlFor="email" className="block text-sm text-gray-700 mb-1">
            Email Address
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={onChange}
            onBlur={() => handleBlur('email')}
            className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black ${
              shouldShowError('email') ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {shouldShowError('email') && (
            <p className="text-xs text-red-500 mt-1">{errors.email}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailForm;
